import { h, Component } from 'preact'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class Post extends Component {
  constructor(props) {
    super(props)

    const container = document.getElementById('js-products-app')
    this.state = {
      active: false,
      activeClass: '',
      triggerText: container.dataset.readmore
    }

    this.handleToggle = this.handleToggle.bind(this)
  }

  handleToggle() {
    const container = document.getElementById('js-products-app')
    if (this.state.active) {
      this.setState({
        active: !this.state.active,
        activeClass: '',
        triggerText: container.dataset.readmore
      })
    } else {
      this.setState({
        active: !this.state.active,
        activeClass: 'active',
        triggerText: container.dataset.readless
      })
    }
  }

  render() {
    let { post, invoice, appointment } = this.props

    let styles = post.product_style_names.join(', ')
    let invoice_url = `${invoice}/?product=${post.slug}&product_id=${post.id}`
    let appointment_url = `${appointment}/?product=${post.slug}`

    const container = document.getElementById('js-products-app')

    const { priceindication, size, metric, invoicetext, appointmenttext } = container.dataset

    return (
      <div className="c-product c-products__col" id={post.slug}>
        <div className="c-product__image" dangerouslySetInnerHTML={{ __html: post.feat_image }} />

        <div className="c-product__body">
          <p className="c-product__styles" dangerouslySetInnerHTML={{ __html: styles }} />
          <h3 className="c-product__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />

          {post.product_price && post.product_length && post.product_width ? (
            <p className="c-product__meta">
              {priceindication} € <span dangerouslySetInnerHTML={{ __html: post.product_price }} /> {size}{' '}
              <span dangerouslySetInnerHTML={{ __html: post.product_length }} /> x{' '}
              <span dangerouslySetInnerHTML={{ __html: post.product_width }} /> {metric}
            </p>
          ) : null}

          {post.content.rendered ? (
            <div className={`c-product-toggle ${this.state.activeClass}`} onClick={this.handleToggle}>
              <div className="c-product-toggle__trigger">
                {this.state.triggerText}
                <div class="c-product-toggle__expand">
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="c-product-toggle__panel" dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
            </div>
          ) : null}

          <div className="c-product__buttons">
            {invoicetext ? (
              <a href={invoice_url} className="c-product__button c-product__button--black">
                {invoicetext}
                <svg class="c-icon c-product__icon">
                  <use href="#slider-chevron-right" xlinkHref="#slider-chevron-right"></use>
                </svg>
              </a>
            ) : null}

            <a href={appointment_url} className="c-product__button c-product__button--border">
              {appointmenttext}
              <svg class="c-icon c-product__icon">
                <use href="#slider-chevron-right" xlinkHref="#slider-chevron-right"></use>
              </svg>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Post



// WEBPACK FOOTER //
// ./src/js/products/containers/Post.js